<template>
  <div class="flex h-auto bg-gray-900 text-white">
    <!-- Sidebar -->
    <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
      <div class="flex items-center justify-center space-x-3">
        <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
      </div>
      <Navbar></Navbar>
    </aside>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <!-- Top Navbar -->
      <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
        <h2 class="text-xl font-semibold">Users</h2>
      </header>

      <!-- Users Page -->
      <main class="p-6 flex-1">
        <div class="bg-gray-800 p-6 rounded-xl shadow-md flex flex-col h-full">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold">Users Overview</h3>

            <!-- Search Input -->
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search users..."
              class="px-3 py-2 rounded-md bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring focus:ring-blue-500"
            />
          </div>

          <div class="overflow-x-auto">
            <table class="w-full text-left border-collapse">
              <thead>
                <tr class="bg-gray-700">
                  <th class="p-3">User ID</th>
                  <th class="p-3">Full Name</th>
                  <th class="p-3">Address</th>
                  <th class="p-3">City</th>
                  <th class="p-3">State</th>
                  <th class="p-3">Creation Date</th>
                  <th class="p-3">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="user in filteredUsers"
                  :key="user.id"
                  class="border-b border-gray-600"
                >
                  <td class="p-3">#{{ user.id }}</td>
                  <td class="p-3">{{ user.name }}</td>
                  <td class="p-3">{{ user.address }}</td>
                  <td class="p-3">{{ user.city }}</td>
                  <td class="p-3">{{ user.state }}</td>
                  <td class="p-3">{{ formatDate(user.date) }}</td>
                  <td class="p-3">
                    <button
                      class="px-3 py-1 bg-blue-500 rounded hover:bg-blue-600"
                      @click="viewUser(user.id)"
                    >
                      View
                    </button>
                    <button
                      class="px-3 py-1 bg-red-500 rounded hover:bg-red-600 ml-2"
                      @click="deleteUser(user.id)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
                <tr v-if="filteredUsers.length === 0">
                  <td colspan="7" class="p-3 text-center text-gray-400">
                    No users found.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>

    <!-- Toast Notifications -->
    <ToastManager ref="toastManager" />
  </div>
</template>

<script>
import Navbar from '@/components/adminnav.vue';
import ToastManager from '@/components/ToastManager.vue';
import axios from 'axios';

export default {
  name: "UsersPage",
  components: { Navbar, ToastManager },
  data() {
    return {
      users: [],
      searchQuery: ""
    };
  },
  computed: {
    filteredUsers() {
      if (!this.searchQuery) return this.users;
      const query = this.searchQuery.toLowerCase();
      return this.users.filter(user =>
        (user.name && user.name.toLowerCase().includes(query)) ||
        (user.address && user.address.toLowerCase().includes(query)) ||
        (user.city && user.city.toLowerCase().includes(query)) ||
        (user.state && user.state.toLowerCase().includes(query)) ||
        (String(user.id).includes(query))
      );
    }
  },
  methods: {
    async fetchUsers() {
      try {
        const response = await axios.get('https://api.syniac.com:3000/api/admin/user/listUsers', { withCredentials: true });
        this.users = response.data;
      } catch (error) {
        console.error("Error fetching users:", error);
        this.$refs.toastManager?.addToast('Failed to fetch users.', 'error');
      }
    },
    viewUser(userId) {
      this.$router.push(`/user/${userId}`);
    },
    async deleteUser(userId) {
      if (!confirm("Are you sure you want to delete this user?")) return;

      try {
        await axios.delete(`https://api.syniac.com:3000/api/admin/user/${userId}`, { withCredentials: true });
        this.$refs.toastManager?.addToast('User deleted successfully!', 'success');
        this.fetchUsers(); // refresh list
      } catch (error) {
        console.error("Error deleting user:", error);
        this.$refs.toastManager?.addToast('Failed to delete user.', 'error');
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-US");
    }
  },
  mounted() {
    this.fetchUsers();
  }
};
</script>

<style scoped>
/* optional: add hover table row effect */
tbody tr:hover {
  background-color: rgba(59, 130, 246, 0.2);
}
</style>
